import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../services/error.service';
import {SweetalertService} from '../../../services/sweetalert.service';
import {AuthService} from '../../../services/auth.service';
import {AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import Swal from 'sweetalert2';
import {ProposalModel} from '../../../models/requests/proposal/proposal.model';
import {AuthorModel} from '../../../models/requests/author/author.model';
import {MembershipModel} from '../../../models/requests/membership/membership.model';
import {PublisherModel} from '../../../models/requests/publisher/publisher.model';
import {PublicationModel} from '../../../models/requests/publication/publication.model';
import {PublicationCostModel} from '../../../models/requests/publicationCost/publicationCost.model';


@Component({
  selector: 'app-proposal',
  templateUrl: './proposal.component.html',
  styleUrls: ['./proposal.component.scss']
})
export class ProposalComponent implements OnInit {

  public isLoading;
  public selectedPool = null;
  public stage1: FormGroup = this.formBuilder.group({
    pool: [null, Validators.required],
  });
  public stage2: FormGroup = this.formBuilder.group({
    poolPublicationType: [null, Validators.required],
    amountFunding: [null, Validators.required],
    publishTitle: [null, Validators.required],
    isbn: [null, [Validators.required, this.ValidatorISBN()]],
    authors: this.formBuilder.array([]),
    publisher: this.formBuilder.array([])
  });
  public stage3: FormGroup = this.formBuilder.group({
    authors: this.formBuilder.array([]),
    publisher: this.formBuilder.array([]),
  });
  public stage4: FormGroup = this.formBuilder.group({
    authorPublishings: this.formBuilder.array([]),
    publisherPublishings: this.formBuilder.array([]),
    descriptionPublication: [null, Validators.required],
    justificationPublishing: [null, Validators.required],
    descriptionCreativeActivityApplicant: [null, Validators.required],
  });
  public stage5: FormGroup = this.formBuilder.group({
    author: [null, Validators.required],
    title: [null, Validators.required],
    publisher: [null, Validators.required],
    isbn: [null, [Validators.required, this.ValidatorISBN()]],
    publishDate: [null, Validators.required],
    amountFunding: [null, Validators.required],
    publishingSheets: [null, Validators.required],
    numberPages: [null, Validators.required],
    numberIllustrations: [null, Validators.required],
    isbnPublication: [null, Validators.required],
    bookForm: [null, Validators.required],
    preparationForPrinting: [null, Validators.required],
    publisherCost: [null, Validators.required],
    copyrightFee: [null, Validators.required],
    retailPrice: [null, Validators.required],
    printRun: [null, Validators.required],
    publicationFinished: [null, Validators.required],
    billingDateForRequest: [null, Validators.required],
  });
  public stage7: FormGroup = this.formBuilder.group({
    consentOne: [null, Validators.required],
    consentTwo: [null, Validators.required],
    consentThree: [null, Validators.required],
  });
  public draft;
  public isErrorPesel = false;
  public isErrorNip = false;
  public fileToUpload: File = null;
  public files = [];
  public typesPublication = [];
  public maximumAmountForType = 0;
  public invalidAmountFunding = true;
  private observer: any = new Subject();
  public pools = this.observer.asObservable();

  constructor(private apiService: ApiService,
              private errorService: ErrorService,
              private sweetalertService: SweetalertService,
              private authService: AuthService,
              public formBuilder: FormBuilder
  ) {
  }

  get authors(): FormArray {
    return this.stage2.get('authors') as FormArray;
  }

  get publisher(): FormArray {
    return this.stage2.get('publisher') as FormArray;
  }

  get authorsMembership(): FormArray {
    return this.stage3.get('authors') as FormArray;
  }

  get publisherMembership(): FormArray {
    return this.stage3.get('publisher') as FormArray;
  }

  get authorPublishings(): FormArray {
    return this.stage4.get('authorPublishings') as FormArray;
  }

  get publisherPublishings(): FormArray {
    return this.stage4.get('publisherPublishings') as FormArray;
  }

  nipValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value === '' || control.value == null) {
        return null;
      }

      let nip = control.value;

      if (nip.length != 10) {
        return {notNip: {value: control.value}};
      }

      nip = nip.replace(/[\ \-]/gi, '');

      const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      let sum = 0;
      const controlNumber = parseInt(nip.substring(9, 10));
      const weightCount = weight.length;

      for (let i = 0; i < weightCount; i++) {
        sum += (parseInt(nip.substr(i, 1)) * weight[i]);
      }

      if (sum % 11 != controlNumber) {
        return {nip: {value: control.value}};
      }

      return null;
    };
  }


  ValidatorISBN(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }

      const regex = /^(?:ISBN(?:-13)?:?\ )?(?=[0-9]{13}$|(?=(?:[0-9]+[-\ ]){4})[-\ 0-9]{17}$)97[89][-\ ]?[0-9]{1,5}[-\ ]?[0-9]+[-\ ]?[0-9]+[-\ ]?[0-9]$/;

      if (regex.test(control.value)) {
        return null;
      }

      return {ISBN: {value: control.value}};
    };
  }

  validatorPhone(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }
      const regex = /[- +()0-9]{9,}/;

      if (regex.test(control.value)) {
        return null;
      }

      return {phone: {value: control.value}};
    };
  }


  validatorPesel(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }

      const pesel = control.value;
      const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
      let sum = 0;
      const controlNumber = parseInt(pesel.substring(10, 11));

      for (let i = 0; i < weight.length; i++) {
        // tslint:disable-next-line:radix
        sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
      }
      sum = sum % 10;
      const isValid = (10 - sum) % 10 === controlNumber;

      if (isValid) {
        return null;
      }

      return {pesel: {value: control.value}};
    };
  }

  ngOnInit(): void {
    this.loadPools();
    this.pools.subscribe(data => {
      this.loadDrafts();
    });

    this.addAuthor();
    this.addPublisher();
    this.addAuthorPublishings();
    this.addPublisherPublishings();
  }

  public buildAuthor(): FormGroup {
    return this.formBuilder.group({
      name: [null, Validators.required],
      lastname: [null, Validators.required],
      nickname: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, this.validatorPhone()]],
      pesel: [null, [Validators.required, this.validatorPesel()]],
      street: [null, Validators.required],
      postcode: [null, Validators.required],
      city: [null, Validators.required],
      country: [null, Validators.required],
    });
  }

  public buildPublisher(): FormGroup {
    return this.formBuilder.group({
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, this.validatorPhone()]],
      street: [null, Validators.required],
      postcode: [null, Validators.required],
      city: [null, Validators.required],
      country: [null, Validators.required],
      nip: [null, [Validators.required, this.nipValidator()]],
      krsceidg: [null, Validators.required],
    });
  }

  public buildAuthorMembership(): FormGroup {
    return this.formBuilder.group({
      memberAssociation: [false, Validators.required],
      contractConcluded: [false, Validators.required],
    });
  }

  public buildPublisherMembership(): FormGroup {
    return this.formBuilder.group({
      memberAssociation: [false, Validators.required],
      contractConcluded: [false, Validators.required],
    });
  }

  public buildAuthorPublishings(): FormGroup {
    return this.formBuilder.group({
      author: [null, Validators.required],
      title: [null, Validators.required],
      isbn: [null, [Validators.required, this.ValidatorISBN()]],
      publisher: [null, Validators.required],
      publishDate: [null, [Validators.required, Validators.min(1950), Validators.max(new Date().getFullYear())]],
      roleInPublication: [null, Validators.required],
      reportedPlr: [false, Validators.required],
      reportedSubContract: [false, Validators.required],
      reportedMembershipDeclaration: [false, Validators.required],
    });
  }

  public buildPublisherPublishings(): FormGroup {
    return this.formBuilder.group({
      author: [null, Validators.required],
      title: [null, Validators.required],
      isbn: [null, [Validators.required, this.ValidatorISBN()]],
      publisher: [null, Validators.required],
      publishDate: [null, [Validators.required, Validators.min(1950), Validators.max(new Date().getFullYear())]],
      roleInPublication: [null, Validators.required],
      reportedPlr: [false, Validators.required],
      reportedSubContract: [false, Validators.required],
      reportedMembershipDeclaration: [false, Validators.required],
    });
  }

  addAuthor(): void {
    this.addAuthorMembership();
    this.authors.push(this.buildAuthor());
  }

  addPublisher(): void {
    this.addPublisherMembership();
    this.publisher.push(this.buildPublisher());
  }

  addAuthorMembership(): void {
    this.authorsMembership.push(this.buildAuthorMembership());
  }

  addPublisherMembership(): void {
    this.publisherMembership.push(this.buildPublisherMembership());
  }

  addAuthorPublishings(): void {
    this.authorPublishings.push(this.buildAuthorPublishings());
  }

  addPublisherPublishings(): void {
    this.publisherPublishings.push(this.buildPublisherPublishings());
  }

  public deleteAuthor(i) {
    this.authors.removeAt(i);
    this.authorsMembership.removeAt(i);
  }

  public deleteAuthorPublishing(i) {
    this.authorPublishings.removeAt(i);
  }

  public deletePublisherPublishing(i) {
    this.publisherPublishings.removeAt(i);
  }

  public removeStage(index) {
    const arrayControl = this.stage2.controls.authors as FormArray;
    arrayControl.removeAt(index);
  }

  public validAmountFunding(event) {
    if (event.target.value > this.maximumAmountForType) {
      this.invalidAmountFunding = true;
      return;
    }
    this.invalidAmountFunding = false;
  }

  public loadDrafts() {
    this.apiService.getDraft().subscribe(data => {
      /* tslint:disable */
      if (data['drafts'].length > 0) {
        this.sweetalertService.loadDraftConfirm().then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Swal.fire('Saved!', '', 'success')
            const
              uc = c => c >= 'a' && c <= 'z'
                ? String.fromCharCode(c.charCodeAt() - 32)
                : c,
              toUpperCase = (key, value) => typeof value === 'string'
                ? Array.from(value, uc).join('')
                : value

            this.draft = data['drafts'].slice(-1)[0];
            this.draft = JSON.parse(JSON.stringify(this.draft), toUpperCase);
            this.stage1.patchValue(this.draft.fields);
            this.stage2.patchValue(this.draft.fields);
            this.getTypesPublicationForPool(this.stage1.controls.pool.value);
          } else {
            Swal.fire('Changes are not saved', '', 'info')
          }
          ;
        });

      }
    });
  }

  public changeFormGroupStatusForAuthor(publicationNumber) {
    //this.form.controls['name'].disable();
    const formArray = this.stage4.get('authorPublishings') as FormArray
    const form = formArray.at(publicationNumber) as FormGroup;
    this._setPublishingFieldsStatus(form);
  }

  public changeFormGroupStatusForPublisher(publicationNumber) {
    //this.form.controls['name'].disable();
    const formArray = this.stage4.get('publisherPublishings') as FormArray
    const form = formArray.at(publicationNumber) as FormGroup;
    this._setPublishingFieldsStatus(form);
  }

  public loadPools() {
    this.isLoading = true;
    this.apiService.getAcceptedPools().subscribe((response: any) => {
      this.isLoading = false;
      this.observer.next(response.data);
    }, error => {
      this.sweetalertService.connectionError();
    });
  }

  public selectedPublicationType(type) {
    if (type !== null) {
      for (let i = 0; i < this.typesPublication.length; i++) {
        if (this.typesPublication[i].id == type) {
          this.maximumAmountForType = this.typesPublication[i].maximumAmountAwards;
        }
      }
    }
  }

  public getTypesPublicationForPool(pool) {
    this.isLoading = true;
    if (typeof pool === 'object' && pool !== null) {
      pool = pool.id;
    }
    this.apiService.getPoolPublicationTypesForPool(pool).subscribe((response: any) => {
      this.isLoading = false;
      this.typesPublication = response.data;
      this.maximumAmountForType = response.data.maximumAmountAwards;
    }, error => {
      this.sweetalertService.connectionError();
    });
  }

  public setSelectedPool(pool) {
    this.selectedPool = pool;
    this.getTypesPublicationForPool(pool);
  }

  public saveDraft($event) {

    let data = this.stage1.getRawValue();
    data = {...data, ...this.stage2.getRawValue()};
    this.apiService.saveDraft(data).subscribe(response => {
      //do nothing
    });
  }

  public isValidPesel(pesel) {
    const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum = 0;
    const controlNumber = parseInt(pesel.substring(10, 11));

    for (let i = 0; i < weight.length; i++) {
      sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
    }
    sum = sum % 10;
    this.isErrorPesel = (10 - sum) % 10 !== controlNumber;

    if (this.isErrorPesel === true) {
      this.authors.controls['pesel'].setErrors({'incorrect': true})
    }
  }

  public isValidNip(nip) {
    nip = nip.replace(/[\ \-]/gi, '');

    const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    const controlNumber = parseInt(nip.substring(9, 10));
    const weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
      sum += (parseInt(nip.substr(i, 1)) * weight[i]);
    }

    this.isErrorNip = sum % 11 !== controlNumber;

    if (this.isErrorNip === true) {
      this.publisher.controls['nip'].setErrors({'incorrect': true})
    }
  }

  public formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  public uploadFile(files: FileList) {
    this.fileToUpload = files.item(0);

    this.apiService.postFile(this.fileToUpload).subscribe((response: any) => {
      this.files.push(response.data);
      this.fileToUpload = null;
    }, error => {
      this.errorService.handleError(error);
      this.fileToUpload = null;
    })
  }

  public sendProposal(e) {
    if (this.stage2.controls.amountFunding.value > this.maximumAmountForType) {
      this.sweetalertService.formError('Podałeś za dużą kwotę dofinansowania. Maksymalna kwota dofinansowania w tej puli dla wybranego typu publikacji to ' + this.maximumAmountForType + 'PLN');
      e.preventDefault();
      return;
    }
    const proposal: ProposalModel = {
      pool: this.stage1.controls.pool.value,
      poolPublicationType: this.stage2.controls.poolPublicationType.value,
      amountFunding: this.stage2.controls.amountFunding.value,
      publishTitle: this.stage2.controls.publishTitle.value,
      isbn: this.stage2.controls.isbn.value,
      descriptionPublication: this.stage4.controls.descriptionPublication.value,
      justificationPublishing: this.stage4.controls.justificationPublishing.value,
      status: 0,
      descriptionCreativeActivityApplicant: this.stage4.controls.descriptionCreativeActivityApplicant.value,
    };

    this.apiService.postProposal(proposal).subscribe((response: any) => {

      this.stage2.controls['authors'].value.forEach((item, i) => {
        const author: AuthorModel = {
          proposal: response.data.id,
          name: item.name,
          lastname: item.lastname,
          nickname: item.nickname,
          email: item.email,
          pesel: item.pesel,
          postCode: item.postcode,
          city: item.city,
          street: item.street,
          country: item.country,
          phone: item.phone
        };
        this.apiService.postAuthor(author).subscribe((authorResponse: any) => {
          const membership: MembershipModel = {
            author: authorResponse.data.id,
            publisher: 0,
            memberAssociation: this.stage3.controls.authors.value[i].memberAssociation,
            contractConcluded: this.stage3.controls.authors.value[i].contractConcluded
          };
          this.apiService.postMembership(membership).subscribe((membershipResponse: any) => {
          });
        });
      });

      this.stage2.controls['publisher'].value.forEach((item, i) => {
        const publisher: PublisherModel = {
          proposal: response.data.id,
          email: item.email,
          publisherName: item.name,
          postCode: item.postcode,
          city: item.city,
          street: item.street,
          country: item.country,
          phone: item.phone,
          publisherNip: item.nip,
          krsCeidg: item.krsceidg,
        };

        this.apiService.postPublisher(publisher).subscribe((publisherResponse: any) => {
          const membership: MembershipModel = {
            author: 0,
            publisher: publisherResponse.data.id,
            memberAssociation: this.stage3.controls.publisher.value[i].memberAssociation,
            contractConcluded: this.stage3.controls.publisher.value[i].contractConcluded
          };
          this.apiService.postMembership(membership).subscribe((membershipResponse: any) => {
          });
        });
      });

      this.stage4.controls['authorPublishings'].value.forEach((item, i) => {
        const publication: PublicationModel = {
          proposal: response.data.id,
          author: item.author,
          publisher: item.publisher,
          title: item.title,
          isbn: item.isbn,
          publishDate: item.publishDate,
          roleInPublication: item.roleInPublication,
          reportedPlr: item.reportedPlr,
          reportedSubContract: item.reportedSubContract,
          reportedMembershipDeclaration: item.reportedMembershipDeclaration
        };
        this.apiService.postAuthorPublication(publication).subscribe((authorPublicationResponse: any) => {
        });
      });

      this.stage4.controls['publisherPublishings'].value.forEach((item, i) => {
        const publication: PublicationModel = {
          proposal: response.data.id,
          author: item.author,
          publisher: item.publisher,
          title: item.title,
          isbn: item.isbn,
          publishDate: item.publishDate,
          roleInPublication: item.roleInPublication,
          reportedPlr: item.reportedPlr,
          reportedSubContract: item.reportedSubContract,
          reportedMembershipDeclaration: item.reportedMembershipDeclaration
        };
        this.apiService.postPublisherPublication(publication).subscribe((publisherPublicationResponse: any) => {
        });
      });

      const stage5: PublicationCostModel = {
        proposal: response.data.id,
        author: this.stage5.controls.author.value,
        publisher: this.stage5.controls.publisher.value,
        title: this.stage5.controls.title.value,
        isbn: this.stage5.controls.isbn.value,
        publishDate: this.stage5.controls.publishDate.value,
        amountFunding: this.stage5.controls.amountFunding.value,
        publishingSheets: this.stage5.controls.publishingSheets.value,
        numberPages: this.stage5.controls.numberPages.value,
        numberIllustrations: this.stage5.controls.numberIllustrations.value,
        isbnPublication: this.stage5.controls.isbnPublication.value,
        bookForm: this.stage5.controls.bookForm.value.toString(),
        preparationForPrinting: this.stage5.controls.preparationForPrinting.value,
        publisherCost: this.stage5.controls.publisherCost.value,
        copyrightFee: this.stage5.controls.copyrightFee.value,
        retailPrice: this.stage5.controls.retailPrice.value,
        printRun: this.stage5.controls.printRun.value,
        publicationFinished: this.stage5.controls.publicationFinished.value,
        billingDateForRequest: this.formatDate(this.stage5.controls.billingDateForRequest.value),
      };

      this.apiService.postPublicationCost(stage5).subscribe((publicationCostResponse: any) => {
      });

      this.isLoading = false;
    });
  }

  private _setPublishingFieldsStatus(form: FormGroup) {
    if (form.get('reportedPlr').value == true || form.get('reportedSubContract').value == true) {
      form.get('author').disable();
      form.get('title').disable();
      form.get('isbn').disable();
      form.get('publisher').disable();
      form.get('publishDate').disable();
      form.get('roleInPublication').disable();
    } else {
      form.get('author').enable();
      form.get('title').enable();
      form.get('isbn').enable();
      form.get('publisher').enable();
      form.get('publishDate').enable();
      form.get('roleInPublication').enable();
    }
  }
}
